import { ReactElement, useState } from 'react';
import { classNames } from 'primereact/utils';

import PandingDocuments from './PendingDocuments/PendingDocuments';
import ShippedDocuments from './ShippedDocuments/ShippedDocuments';
import { useSearchParams } from 'react-router-dom';
import { Message } from 'primereact/message';
import { spawn } from 'child_process';

type ReturnShipmentsProps = {
    companyId: number;
};

function ReturnShipments(props: ReturnShipmentsProps): ReactElement {
    const { companyId } = props;
    const [searchParams] = useSearchParams();
    const [isHistoryShown, setHistoryShown] = useState(() => searchParams.has('fileId'));
    return (
        <div className="bg-white min-h-full w-full m flex flex-column pt-4 px-6 border-top-1 border-200 gap-4">
            <div className="w-full flex flex-column">
                <h1 className="font-bold text-900">Request Physical Copies</h1>
                <div>Request physical copies of your 83(b) filings and acknowledgments.</div>
            </div>
            <Message severity="info" className="justify-content-start align-items-start gap-2 font-normal border-blue-200 border-1"
                icon={
                    <span className="p-2 bg-blue-100 border-circle">
                        <i className="pi pi-info-circle text-xl" />
                    </span>
                }
                text={() => {
                    return (
                        <div className="font-normal text-lg">
                            <h4>Physical Copy Shipping Service – $49.95</h4>
                            <div className="text-base mt-1">Physical copies of your documents will be shipped via FedEx 2Day with signature required upon delivery.</div>
                        </div>
                    )
                }}
            />                
            <div className="flex w-full">
                <div className="flex bg-gray-100 border-round px-2 py-1">
                    <div className="flex items-center gap-1">
                        <button
                            onClick={() => setHistoryShown(false)}
                            className={classNames("px-3 py-2 cursor-pointer p-component font-semibold", { "p-card": !isHistoryShown })}>
                            Available Physical Copies
                        </button>
                        <button
                            onClick={() => setHistoryShown(true)}
                            className={classNames("px-3 py-2 cursor-pointer p-component font-semibold", { "p-card": isHistoryShown })}>
                            Shipment History
                        </button>
                    </div>
                </div>
            </div>
            <div className="w-full min-h-full block">
                {
                    !isHistoryShown ? (
                        <PandingDocuments />
                    ) : (
                        <ShippedDocuments />
                    )
                }
            </div>
        </div>
    );
};

export default ReturnShipments;